import { useUserOrganization } from '@modules-deprecated/app/organization'
import { useUserOrganizationMembership } from '@modules-deprecated/app/organization/hooks/useUserOrganizationMembership'

import { Scope } from '../../../../../enums/scope'
import { isAuthorized } from '../../../../../utils/isAuthorized'

export const useIsAccountCreationAvailable = (): boolean => {
  const { organization } = useUserOrganization()
  const { isViaUmbrella } = useUserOrganizationMembership()

  /* Intentionally excluding DK CPAs and BOs */
  return isAuthorized(Scope.ChartOfAccountsWrite) && organization?.countryId !== 'DK' && isViaUmbrella
}
